import { NonNullableStringParameter, useQueryParameter } from '@pba/react-router';
import { RichTextEditor } from 'ui';
import { uploadImage } from 'features/files';
import { useApiClientConfigurationEffect, useNativeBridge, useToolbar, useViewportOverrideEffect } from './hooks';

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const MobileRichTextEditor = () => {
  useApiClientConfigurationEffect();
  useViewportOverrideEffect();

  const placeholder = useQueryParameter('placeholder', NonNullableStringParameter);
  const toolbar = useToolbar();

  const { data, getMentions, isFocused, onChange, onUploading } = useNativeBridge();

  return (
    <div className="mobile-rich-text">
      <RichTextEditor
        data={data}
        isFocusedInitially={isFocused}
        isMobile
        mentions={getMentions}
        onChange={onChange}
        // TODO: This should use uploadImage and probably different apiClient so we can override default headers set by interceptor
        onRequestUpload={uploadImage}
        onUploading={onUploading}
        placeholder={placeholder}
        toolbar={toolbar}
      />
    </div>
  );
};

export default MobileRichTextEditor;
